export default __webpack_public_path__ + "static/media/background.89ac9771.png";